import PropTypes from 'prop-types'
import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import { AddPageContent, ErrorNotification, PageHeader } from 'SRC/ui'
import { Preloader } from 'SRC/ui/Preloader'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getAdForPromo, getActivatePromoError, getProfileLoading } from '../../../selectors'
import { PromoPeriods } from '../../PromoPeriods'
import { setActivatePromoError, setProfileLoading } from '../../../actions'
import { setAppInternalTransitionFunc } from 'SRC/modules/common/actions'
import Router from 'next/router'
import { listingStatuses } from 'SRC/modules/ads/lisitings/constants'

export class ActivatePromo extends React.PureComponent {
  constructor (props) {
    super(props)

    if (Router.router) {
      Router.router.events.on('routeChangeStart', this.onRouteChangeStartHandler)
      Router.router.events.on('routeChangeComplete', this.onRouteChangeCompleteHandler)
    }
  }

  componentDidMount () {
    this.props.setAppInternalTransitionFunc(this.isInternalTransition)
  }

  componentWillUnmount () {
    this.props.setAppInternalTransitionFunc(null)
  }

  onRouteChangeStartHandler = url => {
    if (this.isInternalTransition(url)) {
      this.showSpinner()
    }
  }

  onRouteChangeCompleteHandler = () => {
    this.hideSpinner()
  }

  isInternalTransition = url => /^\/profil.*/.test(url)

  showSpinner = () => {
    this.props.setProfileLoading(true)
  }

  hideSpinner = () => {
    this.props.setProfileLoading(false)
  }
  hideError = () => {
    this.props.setActivatePromoError('')
  }

  render () {
    const { ad, error, isLoading, i18n: { t } } = this.props

    const headerTitle = t('common:Aktiviraj promo')

    const isListingStatusPending = ad?.listingStatus === listingStatuses.PENDING

    const title = ad ? `${!isListingStatusPending
      ? t('common:ZAHTJEV ZA PROMO')?.toUpperCase() : t('common:azuriraj_promo')?.toUpperCase()}: ${ad.titleCompiled}`
      : ''

    return [
      <PageHeader key='header'>{headerTitle}</PageHeader>,
      <AddPageContent
        title={title}
        description={t('common:zahtjev-za-promo-description')}
        descriptionClass='heading-lead'
        key='content'
      >
        <PromoPeriods />
        <ErrorNotification error={error} hideNotification={this.hideError} />
        {isLoading ? <Preloader /> : null}
      </AddPageContent>
    ]
  }
}

const mapStateToProps = state => ({
  ad: getAdForPromo(state),
  error: getActivatePromoError(state),
  isLoading: getProfileLoading(state)
})

ActivatePromo.propTypes = {
  ad: PropTypes.any,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  setActivatePromoError: PropTypes.func.isRequired,
  setProfileLoading: PropTypes.func.isRequired,
  setAppInternalTransitionFunc: PropTypes.func.isRequired
}

ActivatePromo.defaultProps = {
  isLoading: false
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, { setActivatePromoError, setProfileLoading, setAppInternalTransitionFunc }
  )
)

export default enhance(ActivatePromo)
